(function () {
  // FRECCE DEI CAROSELLI.
  // Sta in un file di asset e non nello snippet: le section caricate dalla
  // Section Rendering API — raccomandazioni, visti di recente, drawer del
  // carrello — inseriscono l'HTML ma NON eseguono gli <script> che
  // contiene. Verificato: lo stesso codice eseguito a mano agganciava
  // tutti e sei i pulsanti, dal suo posto nessuno.
  function collega() {
    document.querySelectorAll('.pq-nav').forEach(function (btn) {
      if (btn.dataset.pqOn) return;
      btn.dataset.pqOn = '1';

      // Il carosello si cerca risalendo fino a trovarne uno, invece di
      // ancorarsi a una classe precisa.
      // closest('.w-full.relative') trovava il wrapper esterno da quando
      // gli e' stato aggiunto position: relative per le frecce: quello ha
      // la classe w-full ma il .carousel sta piu' in basso nell'albero, e
      // querySelector su di lui restituiva null solo in certi casi.
      var car = null;
      var p = btn.parentElement;
      while (p && !car) {
        car = p.querySelector('.carousel');
        p = p.parentElement;
      }
      if (!car) return;

      var dir = parseInt(btn.dataset.pqNav, 10);

      // Il passo e' la larghezza di una card piu' il margine, letti dal
      // primo elemento: il margine fa parte del passo, altrimenti dopo
      // qualche scorrimento le card non sono allineate al bordo.
      function passo() {
        var it = car.querySelector('.carousel-item');
        if (!it) return car.clientWidth * 0.8;
        var gap = parseFloat(getComputedStyle(it).marginRight) || 0;
        return it.getBoundingClientRect().width + gap;
      }

      btn.addEventListener('click', function () {
        car.scrollBy({ left: dir * passo(), behavior: 'smooth' });
      });

      function stato() {
        var max = car.scrollWidth - car.clientWidth;
        // La tolleranza di 4px serve perche' su schermi con fattore di
        // scala frazionario scrollLeft non raggiunge mai esattamente il
        // massimo: misurato 266 su un massimo di 265.
        if (dir < 0) btn.hidden = car.scrollLeft <= 4;
        else btn.hidden = car.scrollLeft >= max - 4;
      }

      car.addEventListener('scroll', stato, { passive: true });
      window.addEventListener('resize', stato);
      stato();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', collega);
  } else {
    collega();
  }

  // I caroselli che arrivano dopo: recently-viewed legge dal localStorage
  // e costruisce le card a caricamento avvenuto.
  // La guardia su dataset.pqOn evita il doppio aggancio.
  var obs = new MutationObserver(collega);
  obs.observe(document.body, { childList: true, subtree: true });
  setTimeout(function () { obs.disconnect(); }, 10000);
})();